import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {HttpService} from './http.service';
import * as moment from 'moment';

import {ImageFile} from '../_data-model/image-file';
import {environment} from '../../../environments/environment';

@Injectable()
export class UtilService {
  routerData: any;
  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();
  environment = environment;

  constructor(private http: HttpService,
              private sanitizer: DomSanitizer,
  ) {
  }

  search(url, terms: Observable<string>) {
    return terms.debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => this.searchEntries(url, term));
  }

  searchEntries(url, term): Observable<any> {
    return this.http
      .post(`${url}`, term)
      .map(res => res.json());
  }

  prependUrl(imgPath) {
    return `${environment.BASE_IMAGE_API}${imgPath}`;
  }

  cleanArray(actual) {
    const newArray = [];
    for (let i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  isNil = (value: any): value is (null | undefined) => {
    return value === null || typeof (value) === 'undefined';
  };

  isObject = (value: any): boolean => {
    return value && value.constructor === Object;
  };

  isBlank = (value: any): boolean => {
    return this.isNil(value) ||
      (this.isObject(value) && Object.keys(value).length === 0) ||
      value.toString().trim() === '';
  };

  isPresent = (value: any): boolean => {
    return !this.isBlank(value);
  };

  hasDuplicates(array, key?) {
    const valuesSoFar = Object.create(null);
    for (let i = 0; i < array.length; ++i) {
      const value = array[i][key];
      if (value) {
        if (value in valuesSoFar) {
          return true;
        }
        valuesSoFar[value] = true;
      } else {
        return false;
      }
    }
    return false;
  }

  getBase64Image(imgUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = imgUrl;
      img.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = reject;
    });
  }

  async printPreview(data, coins, type) {
  const base64Image = await this.getBase64Image('assets/images/sandos4u_coupon.png');

  const markup = `
  <html>
    <head>
      <title>Sandos4U Scratch Cards</title>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap" rel="stylesheet">
      <style>
        body {
          font-family: 'Montserrat', sans-serif;
        }

        .coupon {
          position: relative;
          width: 576px;
          height: 281px;
          margin: 20px auto;
          page-break-inside: avoid;
        }

        .bg {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 0;
        }

        .coins, .code, .validity, .expiration {
          font-family: 'Montserrat', sans-serif;
          position: absolute;
          z-index: 1;
        }

        .coins {
          top: 105px;
          left: 70px;
          font-size: 30px;
          font-weight: bold;
          color: white;
          text-shadow: 0 0 0 white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .code {
          top: 110px;
          left: 340px;
          font-size: 24px;
          font-weight: bold;
          color: black;
        }

        .validity {
          bottom: 20px;
          left: 475px;
          font-size: 12px;
          color: #235FB0;
        }

        .expiration {
          bottom: 20px;
          left: 355px;
          font-size: 12px;
          color: #235FB0;
        }

        @media print {
          @page {
            margin: 1cm;
          }
        }
      </style>
    </head>
    <body>
      ${data.map(promo => `
        <div class="coupon">
          <img class="bg" src="${base64Image}" alt="Coupon Background" />
          <div class="coins">${coins || ''}</div>
          <div class="code">${promo.code || ''}</div>
          <div class="validity">${promo.promoStartDate || ''}</div>
          <div class="expiration">${promo.promoEndDate || ''}</div>
        </div>
      `).join('')}
      <script>
        setTimeout(() => {
          ${type === 'print' ? 'window.print(); window.close();' : ''}
        }, 300);
      </script>
    </body>
  </html>`;

  this.print(markup);
}

  printVoucher(data, type) {
    const markup = `
    <html>
      <head>
          <title>Benefit of ${data.benefitName}</title>
          <style>
              body {
                  font-family: Arial;
                  width: 100%;
              }

              #coupon-container {
                max-width: 500px;
                height: 100%;
                display: table;
                margin: auto;
              }

              #coupon-block {
                display: table-cell;
                vertical-align: middle;
              }

              .coupon {
                border: 5px dotted #bbb; /* Dotted border */
                width: 100%;
                border-radius: 15px; /* Rounded border */
                margin: 0 auto; /* Center the coupon */
                max-width: 500px;
            }

            .container {
                padding: 2px 16px;
                background-color: #f1f1f1;
            }

            .img-container {
              padding: 15px;
              text-align: center;
              border-top-left-radius: 12px;
              border-top-right-radius: 12px;
            }

            .voucher-container {
              background-color: #ffffff !important;
              -webkit-print-color-adjust: exact;
            }

            .emp-container {
              border-bottom-left-radius: 12px;
              border-bottom-right-radius: 12px;
            }

            .promo {
                background: #ccc;
                padding: 3px;
            }

            .expire {
                color: red;
            }
            @media print {
              @page {
                  margin: auto;
              }
              #coupon-container {
                max-width: 100%;
                margin: auto;
              }

              #coupon-block {
                display: table-cell;
                vertical-align: middle;
              }

              .img-container {
                padding: 15px;
                text-align: center;
                border-top-left-radius: 12px !important;
                border-top-right-radius: 12px !important;
              }

              .emp-container {
                border-bottom-left-radius: 12px !important;
                border-bottom-right-radius: 12px !important;
              }

              .container {
                  background-color: #f1f1f1 !important;
                  -webkit-print-color-adjust: exact;
              }

              .voucher-container {
                background-color: #ffffff !important;
                -webkit-print-color-adjust: exact;
              }
          }
          </style>
      </head>

      <body ${type === 'print' ? 'onload="window.print();window.close()' : ''}">
          <div id="coupon-container">
          <div id="coupon-block">
          <div class="coupon">
          <div class="img-container container">
            <img src="https://www.sandos4u.com/static/sandos4u/loyalty_web/img/sandos.png" width="30%"  alt=""/>
          </div>
          <img src="${data.benefitLogo}" alt="${data.benefitName}" style="width: 500px;height:400px;">
          <div class="voucher-container container" style="background-color:white;">
            <h2><b>${data.benefitName.toUpperCase()}</b></h2>
            <p>Hi,</p>
            <p>You have a benefit of <strong>${data.benefitName}</strong> at <strong>${data.hotelName}</strong>.</p>
          </div>
          <div class="emp-container container">
            <p><strong>Employee Code:</strong> <span class="promo">${data.empCode}</span></p>
          </div>
          </div>
        </div>
          </div>
      </body>

    </html>`;
    this.print(markup);
  }

  print(markup) {
    const popupWin = window.open('', '_blank', `top=0,left=0,width=${screen.width},height=${screen.height},fullscreen=yes`);
    popupWin.moveTo(0, 0);
    popupWin.document.open();
    popupWin.document.write(`${markup}`);
    popupWin.document.close();
  }

  parseDate(data, listType, keys) {
    if (data) {
      if (data[listType] && data[listType].length) {
        data[listType].forEach(season => {
          if (keys && keys.length) {
            keys.forEach(key => {
              if (season[key]) {
                season[key] = season[key].formatted ? season[key].formatted : season[key];
              }
            });
          }
        });
        return data;
      }
    }
  }

  public translateLang(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }

  uploadImage(event: any) {
    const imageFile: ImageFile = new ImageFile;
    const image = URL.createObjectURL(event.target.files[0]);
    const fileList: FileList = event.target.files;
    console.log('image:::++', image);
    imageFile.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(image);
    imageFile.file = event.target.files[0];
    imageFile.name = imageFile.file.name;
    imageFile.errorUpload = false;
    if (fileList.length > 0 && (imageFile.file.type === 'image/svg' || imageFile.file.type === 'image/png'
      || imageFile.file.type === 'image/jpg' || imageFile.file.type === 'image/jpeg')) {
      if (imageFile.file.size < 1048576) {
        imageFile.errorUpload = false;
      } else {
        imageFile.fileSizeError = true;
      }
    } else {
      imageFile.errorUpload = true;
      console.log('Please upload Images only');
    }
    return imageFile;
  }

  set setRouterEvents(routeData: any) {
    this.routerData = routeData;
  }

  get getRouterEvents() {
    return this.routerData;
  }

  get getPreviousRoute() {
    return this.routerData[this.routerData.length - 2] || this.routerData[this.routerData.length - 1];
  }

  dateParser(data, dateArr) {
    dateArr.forEach(element => {
      if (typeof (data[element]) === 'object' || typeof (data[element]) === 'string') {
        data[element] = this.formatDate(data[element]);
      }
    });
    return data;
  }

  splitDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return {month, day, year};
  }

  formatDate(date) {
    const {month, day, year} = this.splitDate(date);
    return [year, month, day].join('-');
  }

  parseDateStr(date) {
    const {month, day, year} = this.splitDate(date);
    return [month, day, year].join('/');
  }

  getFullName(user) {
    return user['lastName2'] ? `${user['firstName']} ${user['lastName']} ${user['lastName2']}` : `${user['firstName']} ${user['lastName']}`;
  }

  getFullNameConcierge(user) {
    return user['second_last_name'] ? `${user['first_name']} ${user['last_name']} ${user['second_last_name']}` : `${user['first_name']} ${user['last_name']}`;
  }

  dateRangeOverlaps(a_start, a_end, b_start, b_end) {
    if (a_start <= b_start && b_start <= a_end) {
      return true;
    } // b starts in a
    if (a_start <= b_end && b_end <= a_end) {
      return true;
    } // b ends in a
    if (b_start < a_start && a_end < b_end) {
      return true;
    } // a in b
    return false;
  }

  dateFormat(date, momentFormat): string {
    if (date === null) {
      return '';
    }
    const d = moment(date);
    return d.isValid() ? d.format(momentFormat) : '';
  }

  uploadFile(formData): any {
    const url = `file/uploadFile`;
    return Observable.create((observer) => {
      this.newXMLHttpRequest(observer, `${environment.BASE_API}${environment.ROLE}/${url}`, 'POST', formData);
    });
  }

  newXMLHttpRequest(observer, url, method, formData?) {
    const token = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).token : null;
    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          observer.next(JSON.parse(xhr.response));
          observer.complete();
        } else {
          observer.error(JSON.parse(xhr.response));
        }
      }
      return () => {
        xhr.abort();
      };
    };
    xhr.open(method, url, true);
    xhr.setRequestHeader('X-Auth-Token', token);
    if (formData) {
      xhr.send(formData);
    } else {
      xhr.send();
    }
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; // The maximum is exclusive and the minimum is inclusive
  }

  public getModifiedString(str) {
    return str.substring(0, str.lastIndexOf('.')) + '_' + this.getRandomInt(0, 1000000) + str.substring(str.lastIndexOf('.'));
  }

  trimObj(obj) {
    if (obj && !Array.isArray(obj) && typeof obj !== 'object') {
      return obj;
    }
    if (obj && Object.keys(obj) && Object.keys(obj).length) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[key.trim()] = (obj[key] && typeof obj[key] === 'string') ? obj[key].trim() : this.trimObj(obj[key]);
        return acc;
      }, Array.isArray(obj) ? [] : {});
    }
  }

  public handleError(error: Response) {
    if (error.status === 401) {
      return Observable.throw({
        error: 1,
        message: 'Unauthorized',
        responseObj: null
      });
    } else if (error.status === 404) {
      return Observable.throw({
        error: 1,
        message: 'Not found',
        responseObj: null
      });
    } else if (error.status === 500) {
      return Observable.throw(error.json());
    } else {
      return Observable.throw(error.json());
    }
  }

  public parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/util.service.ts